import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { EditDialogColumn } from 'react-md';

import TooltipFontIcon from '../TooltipFontIcon';
import UsersTab from './UsersTab';

const Admin = ({ intl, ...childProps }) => {
  const props = {
    group: 'adminGroup',
    tabTitle: intl.formatMessage({ id: 'adminDashboard.tabs.admins' }),
    displayedAttributes: [
      {
        tableHeader: intl.formatMessage({ id: 'adminDashboard.users.firstName' }),
        attributeKey: 'name',
        editor: {
          style: { minWidth: '150px' },
          inline: true,
        },
      },
      {
        tableHeader: intl.formatMessage({ id: 'adminDashboard.users.lastName' }),
        attributeKey: 'family_name',
        editor: {
          style: { minWidth: '150px' },
          inline: true,
        },
      },
      {
        tableHeader: intl.formatMessage({ id: 'adminDashboard.users.email' }),
        grow: true,
        attributeKey: 'email',
        editor: {
          inline: true,
          updatable: false,
        },
      },
      {
        attributeKey: 'custom:comment',
        editor: {
          id: 'comment_editor',
          large: true,
          maxLength: 200,
          rows: 1,
          maxRows: 6,
          placeholder: intl.formatMessage({ id: 'adminDashboard.users.clickEnterComment' }),
          anchor: {
            x: EditDialogColumn.HorizontalAnchors.INNER_RIGHT,
            y: EditDialogColumn.VerticalAnchors.BOTTOM,
          },
        },
        display: attributeValue => (attributeValue && <TooltipFontIcon tooltipLabel={<div className="myTooltip">{attributeValue}</div>}>comment</TooltipFontIcon>),
      },
    ],
  };
  return <UsersTab {...childProps} {...props} />;
};

Admin.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Admin);



// WEBPACK FOOTER //
// ./src/components/Users/Admins.js